import { mdiPanRight } from '@mdi/js';
import Icon from '@mdi/react';
import ThreeBackground from './ThreeBackground';

const HeroSection = (props) => {
    return (
        <>
        <section id="home" className="hero--section" ref={props.scrollref}>
            <ThreeBackground/>
            <div className="hero--section--content--box">
                <div className="hero--section--content">
                    <p className="section-title">Hello! I'm <span className="section-title-2">Karthick Jayakumar</span></p>
                    <h1 className="hero--section-title">
                        <span className="hero--section--title--color">Full Stack</span>{" "}
                        Developer
                    </h1>
                    <p className="hero--section-description">
                        <mark>
                            Senior Full Stack Developer with 11 years of experience in developing and maintaining cloud-based web applications, mobile applications, web services, and APIs. Proficient in a range of technologies, including Xamarin, .NET Core, and AngularJS. Demonstrated expertise in leading teams and collaborating with cross-functional groups, implementing robust security protocols, and optimizing processes to ensure successful project delivery
                        </mark>
                    </p>
                </div>
                <a className="viewskills btn btn-primary" href="#skills">View my skills <Icon className='arrow-icon' path={mdiPanRight} size={1.5} color="white"/></a>
            </div>
        </section>
        </>
    )
}
export default HeroSection;
